import React, { useState } from 'react';
import { Card, Button, Form, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';
import '../Styles/TrackMyOrder.css';

const TrackMyOrder = () => {
  const [awb, setAwb] = useState('');
  const [trackingData, setTrackingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleTrack = async () => {
    if (!awb) {
      setError('Please enter an AWB number');
      return;
    }

    setError('');
    setLoading(true);
    try {
      const response = await axios.get(`https://backend-matihaat.onrender.com/api/shiprocket/track/${awb}`);
      setTrackingData(response.data);
    } catch (err) {
      setError('Failed to track the order. Please check the AWB number. If the issue persists, please contact customer support at +91919654870373');
    } finally {
      setLoading(false);
    }
  };

  const shipment = trackingData?.tracking_data?.shipment_track?.[0];
  const activities = trackingData?.tracking_data?.shipment_track_activities || [];

  return (
    <div className="track-order-container">
      <Card className="track-card">
        <Card.Body>
          <Card.Title className="text-center mb-4">📦 Track My Order</Card.Title>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Enter AWB Number</Form.Label>
              <Form.Control
                type="text"
                value={awb}
                onChange={(e) => setAwb(e.target.value)}
                placeholder="e.g. 1234567890"
              />
            </Form.Group>
            <Button variant="primary" onClick={handleTrack} disabled={loading}>
              {loading ? <Spinner size="sm" animation="border" /> : 'Track'}
            </Button>
          </Form>
          {error && <Alert variant="danger" className="mt-3">{error}</Alert>}

          {shipment && (
            <div className="tracking-details mt-4">
              <h5>Status: {shipment.current_status || 'N/A'}</h5>
              <p><strong>AWB:</strong> {shipment.awb_code}</p>
              <p><strong>Courier:</strong> {shipment.courier_name}</p>
              <p><strong>Destination:</strong> {shipment.destination}</p>
              <p><strong>Delivered To:</strong> {shipment.delivered_to}</p>
              <p><strong>Expected Delivery:</strong> {shipment.edd || 'Not Available'}</p>
              <p><strong>Tracking Link:</strong> <a href={trackingData.tracking_data.track_url} target="_blank" rel="noreferrer">View Tracking</a></p>
              <hr />
              <h6>Tracking History:</h6>
              <ul>
                {activities.map((activity, idx) => (
                  <li key={idx}>
                    {activity.date} - {activity.activity} ({activity.location})
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default TrackMyOrder;
